/**
 * Enum for defining button types commonly used in HTML buttons.
 */
export var ButtonType;
(function (ButtonType) {
    ButtonType["Button"] = "button";
    ButtonType["Submit"] = "submit";
    ButtonType["Reset"] = "reset"; // Resets form fields to their initial values.
})(ButtonType || (ButtonType = {}));
//# sourceMappingURL=InteractiveButtonElement.js.map